const $ = window.$;


export default class About {
  constructor() {
    this.$history = $('.js-about-history');
    this.bindEvents();
  }


  bindEvents() {
    this.$history.on('click', (e) => {
      const i = $(e.currentTarget).closest('.js-about-contents').index();
      this.onClickHistory(i);
    });
  }


  onClickHistory(i) {
    if(this.$history.eq(i).hasClass('is-active')) {
      this.$history.eq(i).removeClass('is-active')
    } else {
      this.$history.eq(i).addClass('is-active')
    }
    $('.js-about-contents').eq(i).find('.p-about-history__box').stop().slideToggle();
  }
}


/** WEBPACK FOOTER **
 ** ./htdocs_dev/js/view/about.js
 **/